import axios from 'axios';
import api from './api';
const loggingUrl = process.env.REACT_APP_LOG_SERVICE;

const logApi = axios.create({
	baseURL: `${loggingUrl}`,
});

export { api, logApi };
